import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { CircularProgress, Backdrop } from "@mui/material";
// import { getSchema } from "../helpers/schemas/getSchema";
import { getFormInvalid } from "../helpers/getFormInvalid";
import { checkInvalidField } from "../helpers/checkInvalidField";
import EditDialog from "../Dialogs/EditDialog";
// import { applyEditTrackingFields } from "../helpers/applyEditTrackingFields";
import setupEdit from "../helpers/setupEdit";
import { processFiles } from "../helpers/processFiles";
import { onEditSaveAll } from "../helpers/onEditSaveAll";
import { onEditDeleteAll } from "../helpers/onEditDeleteAll";
import { getUserAccess } from "../helpers/getUserAccess";

export default function ObservationEdit(props) {
  const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = React.useState(true);const [isReady, setIsReady] = React.useState(false);
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [importTitle, setImportTitle] = React.useState("New Observation");
  const [editFeature, setEditFeature] = React.useState(null);
  const [editFiles, setEditFiles] = React.useState([]);
  const [editSchema, setEditSchema] = React.useState([]);
  const [project, setProject] = React.useState({});
  const [formErrorMessage, setformErrorMessage] = React.useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        onEdit(props.observation, props.project);
        setProject(props.project);
      } catch (error) {
        console.error("Error getting document:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };
    
    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  // const onAddNew = (project_id) => {
  //   var item = {};
  //   var schema = getSchema("observation");
  //   schema.forEach((fd) => {
  //     item[fd.name] = "";
  //   });

  //   item["id"] = "new";
  //   item["project_id"] = project_id;
  //   item = applyEditTrackingFields(item, props.user);

  //   setIsLoading(false);
  //   setEditSchema(schema);
  //   setEditFeature(item);
  //   setEditFiles([]);
  //   setImportTitle("New Observation");
  //   setEditDialogOpen(true);
  //   setIsLoading(false);
  // };

  const onEdit = (item, proj) => {
    const results = setupEdit({ ...item }, "observation");
    const files = proj.Files.filter((p) => p.observation_id === item.id);
    setIsLoading(false);
    setEditSchema(results.schema);
    setEditFeature({ ...results.item });
    setEditFiles([...files]);
    setImportTitle(`Edit Observation (No:${item.No})`);
    setEditDialogOpen(true);
  };

  const onEditDelete = async () => {
    try {
      setIsLoading(true);
      const savedProj = await onEditDeleteAll(
        project,
        editFeature,
        editFiles,
        "Observations",
        "observation_id",
        props.user,
      );

      setProject({ ...savedProj });
      // setAllObservations([...savedProj.Observations]);
      // onSortChange(sortByValue, [...savedProj.Observations]);
      setEditDialogOpen(false);
      enqueueSnackbar("Observation deleted successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEditSave = async () => {
    try {
      //check for invalid
      var feat = { ...editFeature };
      var invalidResults = getFormInvalid(feat, editSchema);
      if (invalidResults.isInvalid === true) {
        setEditFeature({ ...invalidResults.feature });
        setEditSchema([...invalidResults.schema]);
        setformErrorMessage(invalidResults.formErrorMessage);
        return;
      }

      setIsLoading(true);

      const savedProj = await onEditSaveAll(
        project,
        feat,
        editSchema,
        editFiles,
        "Observations",
        "observation_id",
        props.user,
      );

      props.passUpProject(savedProj);
      // setEditDialogOpen(false);
      // setProject({ ...savedProj });
      // setAllObservations([...savedProj.Observations]);
      // onSortChange(sortByValue, [...savedProj.Observations]);
      enqueueSnackbar("Observation saved successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEditChange = (e) => {
    try {
      var att = editSchema.find((item) => item.name === e.target.name);
      const formErrorMessage = checkInvalidField(e.target.value, att);
      if (att.type === "date" && e.target.value.length > 0) {
        var date = new Date(e.target.value);
        editFeature[e.target.name] = date.toISOString().split("T")[0];
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      } else if (att.type === "bit") {
        editFeature[e.target.name] = e.target.checked;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      } else {
        editFeature[e.target.name] = e.target.value;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      }
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    }
  };

  const onEditFileCommentChange = (e) => {
    var file = editFiles.find((f) => f.id === e.target.id);
    file.comment = e.target.value;
    setEditFiles([...editFiles]);
  };

  const onRemoveEditFile = async (id) => {
    const updatedFiles = editFiles.map((obj) => {
      if (obj.id === id) {
        obj.deleted = true;
        return obj; // Replace the object if its ID matches
      }
      return obj; // Keep other objects as they are
    });

    setEditFiles([...updatedFiles]);
  };

  const getAcceptedFiles = async (files) => {
    try {
      const readyFiles = await processFiles(
        files,
        "observation_id",
        editFeature.id,
      );
      const allFiles = editFiles.concat(readyFiles);
      setEditFiles([...allFiles]);
    } catch (error) {
      console.error("Error getting document:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: "error",
      });
    }
  };

  const onEditCancel = () => {
    setformErrorMessage("");
    setEditDialogOpen(false);
    props.onEditClick();
  };

  const onDrawComplete = (id, pic) => {
    var file = editFiles.find((f) => f.id === id);
    if (file) {
      file.file = pic;
      if (!file.id.startsWith("new_")) {
        file.isDrawn = true;
      }
      setEditFiles([...editFiles]);
    }
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <EditDialog
      allowDeleteAccess={
        getUserAccess(props.user, project.uid, project.Contacts).allowDelete
      }
      feature={editFeature}
      editFiles={editFiles}
      importTitle={importTitle}
      getAcceptedFiles={getAcceptedFiles}
      onEditFileCommentChange={onEditFileCommentChange}
      onRemoveEditFile={onRemoveEditFile}
      schema={editSchema}
      onChange={onEditChange}
      onEditSave={onEditSave}
      onEditDelete={onEditDelete}
      isOpen={editDialogOpen}
      onClose={onEditCancel}
      formErrorMessage={formErrorMessage}
      allowDelete={false}
      allowFiles={true}
      onDrawComplete={onDrawComplete}
    />
  );
}
